
import { StateCreator } from 'zustand';
import {
    WorkflowI,
    WorkflowActionI,
} from '../../../libs/interfaces';

export const createWorkflowSlice: StateCreator<WorkflowI & WorkflowActionI, [], []> = ((set, get) => ({
    step: 'Formulario',
    setStep: (step) => set(() => ({ step })),
    resetSteps: () => set(() => ({
        step: 'Formulario',
    }))
}));
